<template lang="pug">
.container
  .lock-Medium-button
    el-button.float-right(
      size="mini",
      :disabled='localMedium.Editors.length === 0',
      :type="localMedium.editorsActive && localMedium.Editors.length > 0? 'danger' : 'success'",
      :title="localMedium.editorsActive && localMedium.Editors.length > 0? $t('Only selected users can edit medium') : $t('Medium can be edited by anyone')",
      id="MediumEditorsEditor-users-lock",
      @click="handleLockMediumClicked()"
    )
      font-awesome-icon(:icon="localMedium.editorsActive  && localMedium.Editors.length > 0 ? 'lock' : 'unlock'")
  .medium-Editors
    h4 {{ $t('Medium editors:') }}
    el-tag.tag(v-for='editor in localMedium.Editors', :id="'MediumEditorsEditor-editor' + editor.id", :key='editor.id', closable, @close="handleRemoveEditorFromMedium(editor)")
      span {{ editor.nick }}
    p.no-tags-warning(id="MediumEditorsEditor-noEditorsWarning", v-if='localMedium.Editors.length === 0') {{ $t('This medium has no editors, and can be edited by anyone.')}}
  hr.header
  .users-Not-Editors
    p(v-if='usersNotEditors.length > 0') {{ $t('Click on users below to limit editing permission to selected users.') }}
    el-button.tag.tag-unused(
      v-for='user in usersNotEditors',
      size="mini",
      :id="'MediumEditorsEditor-users' + user.id",
      :key='user.id',
      @click="handleAddEditorToMedium(user)"
    )
      span {{ user.nick }}
</template>

<script>
import Vue from 'vue'
export default {
  props: ['medium'],
  mixins: [],
  components: {
  },
  async created () {
    this.allNetworkUsers = (await Vue.axios.get('user/getUsersWithNetworkPermission')).data
  },
  data () {
    return {
      allNetworkUsers: [],
      localMedium: this.medium
    }
  },
  methods: {
    async handleRemoveEditorFromMedium (editor) {
      this.localMedium = (await Vue.axios.post('medium/removeUserFromEditors', {
        mediumId: this.localMedium.id,
        editorId: editor.id
      })).data
    },
    async handleAddEditorToMedium (user) {
      this.localMedium = (await Vue.axios.post('medium/addUserToEditors', {
        mediumId: this.localMedium.id,
        editorId: user.id
      })).data
    },
    async handleLockMediumClicked () {
      this.localMedium = (await Vue.axios.post(`medium/toggleEditorsActive`, {
        mediumId: this.localMedium.id,
        editorsActive: !this.localMedium.editorsActive
      })).data
    }
  },
  computed: {
    usersNotEditors () {
      return this.allNetworkUsers.filter(nu => !this.localMedium.Editors.map(e => e.id).includes(nu.id))
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.tag, button {
  margin: 0px 10px 10px 0px;
  background-color: rgba($--color-primary, 0.6);
  border: 1px solid rgba(black, 0.8);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumEditors.vue